/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RequestAuditCacheFlushRequest extends models.RequestAuditBaseRequest {
    getFixupPrototypeFunction() { return RequestAuditCacheFlushRequest.fixupPrototype; }

    static newInstance(model: Partial<RequestAuditCacheFlushRequest>): RequestAuditCacheFlushRequest {
        let obj = Object.assign(new RequestAuditCacheFlushRequest(), model);
        RequestAuditCacheFlushRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RequestAuditCacheFlushRequest>): RequestAuditCacheFlushRequest {
        if (!model) return null;
        return RequestAuditCacheFlushRequest.newInstance(<RequestAuditCacheFlushRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RequestAuditCacheFlushRequest) {
        if (!obj) return;

        models.RequestAuditCacheFlushRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RequestAuditCacheFlushRequest): boolean {
        if (models.RequestAuditBaseRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RequestAuditCacheFlushRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
